import React from 'react';
import UsariosContent from './components/UsariosContent';

const Panel = props => (
  <UsariosContent {...props} />
);

export default Panel;

// if you want to add select, date-picker and time-picker in your app you need to uncomment the first
// four lines in /scss/components/form.scss to add styles
